/**
 * This place where we put out
 * Chat definitions method
 */

// API calls, SDK methods, filtering data etc and then calling the state mutation method for manipulating the state
export const actions = {
  openModal: 'openModal',
  closeModal: 'closeModal'
};

// only the state manipulator.
export const mutations = {
  updateModalStatus: 'updateModalStatus'
};

export default {
  actions,
  mutations
};
